<dialogtitle title="Help" titleTheme="blue"></dialogtitle>
<mat-dialog-content class="help-content">
  <div>
    <span class="help-content-bold">A helpdesk service is provided and can be accessed here:</span>
    <br><br>
    <span class="help-content-bold">1. IT Helpdesk</span> <br>
    <span> As with any NR system, if you encounter an issue you can raise a ticket via </span>
    <a class="link-anchor" href="https://nwrprod.service-now.com/sp" target="_blank" rel="noopener">
      IT Helpdesk
    </a>
    <br><br>
    <span class="help-content-bold">2. Help Sharepoint </span> <br>
    <span>If you need any further information, including user guides you can access it through the </span>
    <a class="link-anchor" href="https://networkrail.sharepoint.com/sites/IntelligentInfrastructureProgramme/FMS%20Approved%20Library/Forms/AllItems.aspx?csf=1&web=1&e=C9Iqwy&cid=07230d1b%2Df73f%2D492e%2Dbe41%2D2519319bc50b&FolderCTID=0x0120002E1CD031C502794FAC99B83F356E0BEB&id=%2fsites%2fIntelligentInfrastructureProgramme%2fFMS%20Approved%20Library%2fFeedback&viewid=8836d2a5%2Dc4b7%2D48ba%2D99cf%2D72186a8c7817" target="_blank" rel="noopener">
      Sharepoint Site
    </a>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="help-btn-wrapper">
    <button type="button" id="close-button" class="common-button nr-button-active" mat-raised-button mat-dialog-close>
      Close
    </button>
  </div>
</mat-dialog-actions>